import React, { useEffect, useState } from "react";
import {
  requestListRewardsProduct,
  usePointDispatch,
  usePointState,
} from "../../Context";
import { ErrorList } from "../../Components/ErrorList";
import { EmptyList } from "../../Components/EmptyList";
import { Pagination } from "../../Components/Pagination";
import ProductListSkeleton from "../../Components/ProductListSkeleton";
import RewardProduct from "../../Components/RewardProduct";

const RewardProductList = () => {
  const pointDispatch = usePointDispatch();

  const [page, setpage] = useState(1);

  const { products, productLoading, productError, productNextTokens } =
    usePointState();

  useEffect(() => {
    requestListRewardsProduct(pointDispatch, {
      page: 1,
      limit: 8,
    });
  }, [pointDispatch]);

  const onNext = () => {
    const nextPage = page + 1;
    setpage(nextPage);
    if (productNextTokens[nextPage]) {
      requestListRewardsProduct(pointDispatch, {
        page: nextPage,
        limit: 8,
        nextToken: productNextTokens[nextPage],
      });
    }
  };

  const onPrev = () => {
    const prevPage = page - 1;
    setpage(prevPage);
    if (prevPage > 0) {
      requestListRewardsProduct(pointDispatch, {
        page: prevPage,
        limit: 8,
        nextToken: productNextTokens[prevPage],
      });
    }
  };

  const onPageChange = (selectedPage) => {
    setpage(selectedPage);
    if (productNextTokens[selectedPage] || selectedPage === 1) {
      requestListRewardsProduct(pointDispatch, {
        page: selectedPage,
        limit: 8,
        nextToken: productNextTokens[selectedPage],
      });
    }
  };

  return (
    <div>
      <div className="bg-white shadow-sm max-w-7xl mx-auto overflow-hidden px-4 py-6 sm:px-6 rounded-t-lg">
        {productLoading ? (
          <ProductListSkeleton totalItem={4} />
        ) : (
          <div className="flex flex-col gap-4">
            {products?.length > 0 ? (
              <div className="-mx-px grid grid-cols-1 sm:grid-cols-2 sm:mx-0 md:grid-cols-3 lg:grid-cols-4 gap-6">
                {products.map((product) => (
                  <RewardProduct product={product} key={product?.id} />
                ))}
              </div>
            ) : productError ? (
              <ErrorList
                message={productError?.message || "Error fetching product."}
                errors={productError?.errors}
              />
            ) : (
              <EmptyList title="noRewardProducts" />
            )}
          </div>
        )}
      </div>
      <Pagination
        className="rounded-b-lg"
        page={page}
        onPrev={onPrev}
        onNext={onNext}
        onPageChange={onPageChange}
        nextTokens={productNextTokens}
      />
    </div>
  );
};

export default RewardProductList;
